const Quote = () => (
    <div className='quoteContainer'>
           <h4 className='quoteText'>
            “<i className='quotor'>Mathematics</i> is not about numbers, equations,
             computations or algorithms; it's about
              understanding.” <i className='quotor'>--William Paul Thurston</i>
            </h4>
    </div>

);

export default Quote;